import React, { useEffect, useState, useRef, Fragment } from 'react';
export function Countdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 34,
    seconds: 2
  });
  const sectionRef = useRef<HTMLElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (!sectionRef.current) return;
    const observer = new IntersectionObserver(([entry]) => setIsVisible(entry.isIntersecting), {
      rootMargin: '100px'
    });
    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (hours === 0 && minutes === 0 && seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          return {
            hours: 0,
            minutes: 0,
            seconds: 0
          };
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [isVisible]);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <section ref={sectionRef} className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(255,255,255) 18%, rgb(255,255,255) 78%, rgb(254,242,242) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-70">
      <div className="mx-auto max-w-4xl text-center" data-id="element-71">
        <div className="mx-auto max-w-xl rounded-xl border border-red-300 bg-white px-5 py-4 shadow-sm" data-id="element-72">
          <p className="text-xs font-black uppercase tracking-[2px] text-red-600 m-0 mb-1" data-id="element-73">
            🔥 Precio especial activo
          </p>

          <h2 className="text-lg sm:text-xl font-black text-gray-900 m-0 mb-4" data-id="element-74">
            El precio de lanzamiento termina pronto
          </h2>

          <div className="mb-4 flex items-center justify-center gap-2" data-id="element-75">
            {[{
            value: pad(timeLeft.hours),
            label: 'hs'
          }, {
            value: pad(timeLeft.minutes),
            label: 'min'
          }, {
            value: pad(timeLeft.seconds),
            label: 'seg'
          }].map((item, index) => <Fragment key={item.label} data-id="element-76">
                <div className="flex min-w-[60px] flex-col items-center rounded-lg bg-red-100 px-2 py-2 border border-red-200" data-id="element-77">
                  <span className="text-3xl sm:text-4xl font-black tabular-nums text-red-700 leading-none" data-id="element-78">
                    {item.value}
                  </span>
                  <span className="mt-1 text-[10px] uppercase tracking-wide text-gray-500" data-id="element-79">
                    {item.label}
                  </span>
                </div>

                {index < 2 && <span className="text-3xl sm:text-4xl font-black text-red-500" data-id="element-80">
                    :
                  </span>}
              </Fragment>)}
          </div>

          <p className="text-sm font-bold text-gray-900 m-0 mb-4" data-id="element-81">
            Después aumenta{' '}
            <span className="font-black text-red-600" data-id="element-82">$25.000 ARS</span>.
          </p>

          <div className="mx-auto max-w-md" data-id="element-83">
            <div className="mb-1 flex items-center justify-between" data-id="element-84">
              <span className="text-xs font-bold text-red-600" data-id="element-85">
                Cupos al precio actual
              </span>
              <span className="text-xs font-bold text-gray-900" data-id="element-86">
                82% tomados
              </span>
            </div>

            <div className="h-3 w-full overflow-hidden bg-gray-200 rounded-full" data-id="element-87">
              <div className="h-3 rounded-full" style={{
              width: '82%',
              backgroundImage: 'linear-gradient(to right, rgb(220,38,38), rgb(249,115,22))'
            }} data-id="element-88" />
            </div>

            <p className="text-right text-[10px] text-gray-500 mt-1 mb-0" data-id="element-89">
              Últimos accesos con este precio
            </p>
          </div>
        </div>
      </div>
    </section>;
}